import React from "react";

import { DEFAULT_CARD_HEIGHT, TAG } from "config/constants";
import TagStreamWrapper from "stream/containers/TagStreamWrapper";
import Stream from "stream/containers/Stream";
import FullStoryCard from "cards/containers/FullStoryCard";
import PromoStreamCap from "stream/components/PromoStreamCap";
import Helmet from "react-helmet-async";
import IssuesModule from "stream/containers/IssuesModule";

import image from "assets/img/business-of-sports-deep-dive.png";
import ogImage from "assets/img/business-of-sports-deep-dive-social.jpg";

export default function BusinessOfSportsTagStream() {
  const StreamShoe = () => (
    <IssuesModule
      boxes={[
        {
          name: "Esports",
          tagSlug: "esports",
          backgroundColor: "#a0dc29",
        },
        {
          name: "Sports Betting",
          tagSlug: "sports-betting",
          backgroundColor: "#ef5c66",
        },
        {
          name: "NFL",
          tagSlug: "national-football-league-nfl",
          backgroundColor: "#00d0e3",
        },
        {
          name: "Super Bowl",
          tagSlug: "super-bowl",
          backgroundColor: "#ff9300",
        },
      ]}
    />
  );

  return (
    <React.Fragment>
      <Helmet>
        <meta property="og:image" content={ogImage} />
      </Helmet>
      <TagStreamWrapper slug={TAG.BUSINESS_OF_SPORTS.slug}>
        {({ streamParams }) => (
          <React.Fragment>
            <PromoStreamCap
              promo={{
                title: "The evolution of sports consumption and fandom",
                content: (
                  <span>
                    Explore below and{" "}
                    <a
                      className="gtm-promo-stream-cap-content-link"
                      href="https://signup.axios.com/2019/am.html?source=axios&medium=referral&campaign=stream_cap_promo_link"
                    >
                      sign up for Axios AM{" "}
                    </a>
                    for more deep dives into the most important topics affecting
                    our world.
                  </span>
                ),
                contentForAnalytics:
                  "Explore below and sign up for Axios AM for more deep dives into the most important topics affecting our world.",
                image: image,
              }}
            />
            <Stream
              {...streamParams}
              defaultCardHeight={DEFAULT_CARD_HEIGHT.FULL_STORY_CARD}
              contentComponent={FullStoryCard}
              streamShoeComponent={StreamShoe}
            />
          </React.Fragment>
        )}
      </TagStreamWrapper>
    </React.Fragment>
  );
}
